import { Help } from '@velocity-exchange/icons';
import CurrentRpcHealth from 'src/components/CurrentRpcHealth';
import Divider from 'src/components/primitives/Divider/Divider';
import { VELOCITY_DISCORD_URL } from 'src/constants/constants';
import { MODAL_PADDING } from 'src/components/primitives/BaseModal/consts';
import Link from 'src/components/primitives/Link/Link';
import { cj } from 'src/utils/classNames';
// FE-4392: Feature Announcements hidden — re-add later
// import FeatureAnnouncementTrigger from 'src/components/FeatureAnnouncementTrigger/FeatureAnnouncementTrigger';

export default function MobileNavFooter() {
	return (
		<>
			<div className={MODAL_PADDING.horizontal}>
				{/* FE-4392: Feature Announcements hidden — re-add later */}
				{/* <FeatureAnnouncementTrigger className="p-0 text-text-default" /> */}
			</div>
			<Divider />
			<CurrentRpcHealth
				className={cj('text-text-default', MODAL_PADDING.horizontal)}
				mobile
			/>
			<Divider />
			<Link
				variant="primary"
				className={MODAL_PADDING.horizontal}
				href={VELOCITY_DISCORD_URL}
				leftIcon={Help}
				rightIcon="none"
				openInNewTab
			>
				Support
			</Link>
		</>
	);
}
